<template> 
   <v-card class="side-menu d-flex flex-column align-stretch" style="">
        <v-layout class="flex-grow-0 pt-1 pl-3" align-center>
            <template v-if="tagsApplied > 0 && taxonomiesMenu">
                <span>Tags applied: {{ tagsApplied }}</span>
                <uv-button icon small 
                @click="toggleFilter" 
                :title="filterApplied ? 'Show all tags' : 'Show only applied tags'"
                :color="filterApplied ? 'warning' : 'success'">
                    <v-icon>{{ filterApplied ? icons.filterOff : icons.filter }}</v-icon>
                </uv-button>
            </template>
            <uv-button icon></uv-button>
            <v-spacer></v-spacer>
            <uv-button  @click="closeSideMenu" icon title="Close XBRL Menu">
                <v-icon>mdi-close-circle-outline</v-icon>
            </uv-button>
        </v-layout>
        <slot></slot>
    </v-card>
    
</template>

<script>
import { mapState } from "vuex";
import { mdiFilter, mdiFilterOff } from "@mdi/js";
export default {
    name: "PageSideMenu",
    props: {
        taxonomiesMenu: {
            type: Boolean,
            default: true
        },
        filterApplied: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            icons: {
                filter: mdiFilter,
                filterOff: mdiFilterOff
            }
        };
    },
    methods: {
        closeSideMenu() {
            this.$store.dispatch('xbrlData/closeSideMenu');
        },
        toggleFilter() {
            this.$emit("update:filterApplied", !this.filterApplied);
        },  
    },
    computed:{
        ...mapState("xbrlData", {
            selectionAttributes: state => state.selectionAttributes,
            reportTags: state => state.reportTags,
        }),
        tagsApplied(){
            if (this.selectionAttributes.row && this.selectionAttributes.table){
                const tableId = this.selectionAttributes.table
                const rowId = this.selectionAttributes.row
                return this.reportTags[tableId]?.rows[rowId]?.length || 0
            }else{
                return (
                    this.selectionAttributes?.marks?.length ||
                    this.selectionAttributes?.textBlock?.length ||
                    0
                )
            }
        }
    }
}
</script>

<style lang="scss" scoped>
   .side-menu {
        min-height: 70vh;
        max-height: 77vh;
        width: 65vw;
        background-color: white;
    }
</style>
